module.exports = __webpack_public_path__ + "static/media/team.284f8698.jpg";